import {SmartComponent} from "smart-component-js";
import GenericModalComponent from "../utils/GenericModalComponent";

class ReengagementModalComponent extends SmartComponent {

    constructor(element, parentComponent, params) {
        super(element, parentComponent, params);
        this.element = element;
        this.modal = new GenericModalComponent(this.element);
        this.exit = this.element.querySelector('.exit a');
        this.mission = this.element.dataset.engagement;

        this.init();
    }

    checkReengageMission() {
        if (this.mission === 'true') {
            this.modal.openModal();
        }
    }

    addModalListener() {
        this.exit.addEventListener('click', () => {
            this.modal.closeModal();
        })
    }


    init() {
        this.checkReengageMission();
        this.addModalListener();
    }
}

export default ReengagementModalComponent;
